module.exports = __webpack_public_path__ + "static/media/RBG_art_Angelica_Fernandez.7a1db84a.png";